<template>
  <el-dialog title="编辑" :visible="true" :before-close="closeBox">
    <el-form>
      <el-form-item label="物流名称">
        <el-input
          v-model="form.logistics_name"
          placeholder="物流名称"
          :disabled="form.logistics_id != ''"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系人">
        <el-input v-model="form.contacts" placeholder="联系人"></el-input>
      </el-form-item>
      <el-form-item label="联系电话">
        <el-input
          v-model="form.contacts_phone"
          placeholder="联系电话"
        ></el-input>
      </el-form-item>
      <el-form-item label="状态:">
        <el-select v-model="form.status" placeholder="状态">
          <el-option
            v-for="item in status_ops"
            :key="item.key"
            :label="item.name"
            :value="item.key"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="备注说明">
        <el-input v-model="form.remark" placeholder="备注说明"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeBox">取 消</el-button>
      <el-button type="primary" @click="addLogistics">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    logistics_id: {
      type: String,
      default: "",
    },
    logistics_name: {
      type: String,
      default: "",
    },
    contacts: {
      type: String,
      default: "",
    },
    contacts_phone: {
      type: String,
      default: "",
    },
    remark: {
      type: String,
      default: "",
    },
    status: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      form: {
        logistics_id: "",
        logistics_name: "",
        contacts: "",
        contacts_phone: "",
        remark: "",
        status: "",
      },
      status_ops: [
        { key: "1", name: "启用" },
        { key: "2", name: "禁用" },
      ],
    };
  },
  mounted() {
    this.filteredForm();
  },
  methods: {
    filteredForm() {
      this.form.logistics_id = this.logistics_id;
      this.form.logistics_name = this.logistics_name;
      this.form.contacts = this.contacts;
      this.form.contacts_phone = this.contacts_phone;
      this.form.remark = this.remark;
      this.form.status = this.status;
    },
    addLogistics() {
      let url = "/erp/logistics/saveLogistics";
      if (this.form.logistics_id) {
        url = "/erp/logistics/editLogistics";
      }
      console.log(this.form.logistics_id);
      this.$http.post(url, this.form).then(res => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$message.success(res.data.msg);
          this.visible = false;
          this.closeBox();
        }
      });
    },
    closeBox() {
      this.$emit("onCloseDialog", false);
    },
  },
};
</script>

<style scoped>
.bottom-buttom {
  display: flex;
  flex-direction: row;
}
.el-dialog {
  width: 600px !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/logistics/components/edit.vue